// components/about/AboutUsSection.js
import React, { useRef, useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const AboutUsSection = ({ image }) => {
  const sectionRef = useRef(null);

  // Set up intersection observer to detect when section comes into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-16 bg-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-black mb-4">
            About Us
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-red-700 to-red-500 rounded mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <p className="text-lg text-black-300 mb-6">
              Driven by a passion for innovation and a background in IT, Prathamesh Prakash Labde ignited his 
              entrepreneurial spirit in 2018. Fuelled by a love for riding, travel, and fitness, this initial spark has 
              grown into a dynamic business.
            </p>
            <p className="text-lg text-black-300 mb-6">
              His journey began with a simple yet powerful idea, validated when Prathamesh's initial 2D 
              machine design earned top honors in a competition. 
            </p>
            <p className="text-lg text-black-300">
              This success sparked a pivotal moment: the 
              realization that the potential of 3D technology could be harnessed. From that inspiration, his first 
              3D machine was born, marking the commencement of his exciting venture into 3D printing.
            </p>
          </div>

          {/* Image Box with Lazy Loading */}
          <div className="bg-gray-800 p-6 rounded-xl shadow-lg flex items-center justify-center">
            <div className="w-full h-64 md:h-80 rounded-lg overflow-hidden">
              {/* Replace standard img with LazyLoadImage */}
              <LazyLoadImage
                src={image}
                alt="3D Printer"
                effect="blur" 
                threshold={200}
                className="w-full h-full object-cover"
                placeholderSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect width='400' height='400' fill='%23343a40'/%3E%3C/svg%3E"
                wrapperClassName="w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;